  module.exports = {
    contact: {
      title: "We are only one e-mail away",
      description:
        "We endeavor to answer all requests for communication as fast as we can",

      addressTitle: "We are located in Madrid, Spain",
      addressIcon: "fas fa-location-arrow",
      address: "The city of cobalt blue skies.",
      emailTitle: "Our Email Address",
      emailIcon: "fas fa-envelope",
      email: "hello@neomad.life"
    }
  };
